import UI from '../../ui';
import Post from '../../components/Post';
import usePosts from '../../hooks/usePosts';

const HomePage: React.FC = () => {
  const posts = usePosts();
  const postsSliced = posts.slice(0, 3);
  return (
    <UI.VerticalLayout overflow="scroll" gap={30}>
      {postsSliced.map((post, i) => <Post key={i} post={post} />)}
    </UI.VerticalLayout>
  );
};

export default HomePage;
